module.exports = __webpack_public_path__ + "static/media/9.63bc528e.jpg";